import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { DisbursalAccountsState } from "../../../../utils/types";

export const pending = (state: DisbursalAccountsState) => {
  state.isLoading = true;
  state.data = null;
  state.isError = false;
};

export const fulfilled = (
  state: DisbursalAccountsState,
  action: PayloadAction<
    Types.ApiResponse<Types.DisbursalAccountsTypes.DisbursalAccounts[]>
  >
) => {
  state.isLoading = false;
  state.isError = false;
  state.isSuccess = action.payload.success;
  state.data = action.payload.response;
};

export const rejected = (state: DisbursalAccountsState) => {
  state.isLoading = false;
  state.isError = true;
  state.isSuccess = false;
};
